import { Consent, RedirectAttrs } from '../models/commonModels';
import fetch, { getAuthorizationHeaders } from './fetch';

export default (client: RedirectAttrs): Promise<Consent> =>
    fetch<Consent>(
        `/consents/${client.client_id}`,
        {
            method: 'GET',
            headers: getAuthorizationHeaders(),
        },
        client
    );

export const setUserConsentForClient = (client: RedirectAttrs, consent: Consent): Promise<{ redirect_uri: string }> =>
    fetch<{ redirect_uri: string }>(
        '/authorize',
        {
            method: 'POST',
            headers: getAuthorizationHeaders(),
            body: JSON.stringify(consent),
        },
        client
    );
